<template>
  <div class="top-data-box">
    <div class="data-1">
      <div class="data-item">
        <div class="item-title">全部</div>
        <div class="item-value">{{ contractCount[0] || 0 }}</div>
      </div>
    </div>

    <div class="data-2">
      <div class="data-item">
        <div class="item-title">签署中</div>
        <div class="item-value">{{ contractCount[10] || 0 }}</div>
      </div>
      <div class="item-line"></div>
      <div class="data-item">
        <div class="item-title">
          当日未完成
          <el-tooltip
            class="item"
            effect="dark"
            content="含 “三天内 / 七天内未完成” 的数据"
            placement="top"
          >
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </div>
        <div class="item-value">{{ contractCount[16] }}</div>
      </div>
      <div class="item-line"></div>
      <div class="data-item">
        <div class="item-title">
          拖延三天以上

          <el-tooltip
            class="item"
            effect="dark"
            content="含 “七天内未完成” 的数据"
            placement="top"
          >
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </div>
        <div class="item-value">{{ contractCount[17] }}</div>
      </div>
      <div class="item-line"></div>
      <div class="data-item">
        <div class="item-title">拖延七天以上</div>
        <div class="item-value">{{ contractCount[18] }}</div>
      </div>
    </div>

    <div class="data-3">
      <div class="data-item">
        <div class="item-title">审核中</div>
        <div class="item-value">{{ contractCount[11] || 0 }}</div>
      </div>
    </div>

    <div class="data-4">
      <div class="data-item">
        <div class="item-title">已出证</div>
        <div class="item-value">{{ contractCount[12] || 0 }}</div>
      </div>
    </div>

    <div class="data-line-red"></div>

    <div class="data-5">
      <div class="data-item">
        <div class="item-title">公证审核拒绝</div>
        <div class="item-value">{{ contractCount[14] || 0 }}</div>
      </div>
    </div>

    <div class="data-6">
      <div class="data-item">
        <div class="item-title">
          到期未签署
          <el-tooltip
            class="item"
            effect="dark"
            content="发起后30天内未完成赋强"
            placement="top"
          >
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </div>
        <div class="item-value">{{ contractCount[15] || 0 }}</div>
      </div>
    </div>
  </div>
</template>
          
<script>
export default {
  name: "topData",
  props: {
    contractCount: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  components: {},

  data() {
    return {};
  },

  created() {},
  mounted() {},

  methods: {},
};
</script>
          
<style scoped lang='scss'>
.top-data-box {
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .data-1 {
    width: 11%;
    height: 70px;
    background: #f04132;
    box-shadow: 0px 0px 5px 0px rgba(240, 65, 50, 0.46);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .data-2 {
    width: 38%;
    height: 70px;
    background: #f6705f;
    border-radius: 3px;
    display: flex;
    align-items: center;
  }

  .data-3 {
    width: 11%;
    height: 70px;
    background: #f6705f;
    box-shadow: 0px 0px 5px 0px rgba(242, 103, 30, 0.46);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .data-4 {
    width: 11%;
    height: 70px;
    background: #f6705f;
    box-shadow: 0px 0px 5px 0px rgba(240, 65, 50, 0.46);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .data-5 {
    width: 11%;
    height: 70px;
    background: #f2671e;
    box-shadow: 0px 0px 5px 0px rgba(198, 63, 43, 0.46);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .data-6 {
    width: 11%;
    height: 70px;
    background: #f2671e;
    box-shadow: 0px 0px 5px 0px rgba(206, 118, 111, 0.46);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .data-line-red {
    width: 1px;
    height: 48px;
    background-color: #db1c1b;
  }

  .data-item {
    flex: 1;
    padding: 0 13px;
  }

  .item-line {
    width: 1px;
    height: 48px;
    background-color: #e9e9e9;
  }

  .item-title {
    font-size: 11px;
    line-height: 11px;
    font-weight: 500;
    margin-bottom: 14px;
    display: inline-block;
    position: relative;
    .el-icon-warning {
      position: absolute;
      right: -12px;
      top: -8px;
    }
  }

  .item-value {
    text-align: center;
    font-size: 19px;
  }
}
</style>
          